import {useState, useRef, useEffect} from "react";
import {useTranslation} from "react-i18next";
import Collapse from "react-bootstrap/Collapse";
import {Button, ButtonGroup, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DataRange from "components/datetime/DataRange";
import moment from "moment/moment";

const FormFiltersModel = {
    waste_type: "",
    download_type: "",
    start: "",
    end: "",
};

const FleetRoutesFilters = ({
    filters,
    show,
    applyFilters,
    setItemsShown,
    isLoading,
}) => {
    const {t: _Tt} = useTranslation("tags");
    const [dateRangeSelected, setDateRangeSelected] = useState();
    // -
    const labelStyle = {width: "100%", fontWeight: "bold", textAlign: "center"};
    const [formFilters, setFormFilters] = useState({...FormFiltersModel});
    const defaultRange = useRef({
        start: new Date(),
        end: new Date(),
        startString: "",
        endString: "",
    });

    useEffect(() => {
        defaultRange.current.start = defaultRange.current.start.setDate(
            defaultRange.current.start.getDate() - 6
        );
        defaultRange.current.startString = moment(defaultRange.current.start).format(
            "DD/MM/YYYY"
        );
        defaultRange.current.endString = moment(defaultRange.current.end).format(
            "DD/MM/YYYY"
        );

        setDateRangeSelected(
            `${defaultRange.current.startString} - ${defaultRange.current.endString}`
        );
        filters.current.start = defaultRange.current.startString;
        filters.current.end = defaultRange.current.endString;
    }, []);

    const onChangeSelect = (e) => {
        const {name, value} = e.target;
        setFormFilters({...formFilters, [name]: value});
        if (value) {
            filters.current[name] = value;
        } else {
            delete filters.current[name];
        }
    };

    const handleClearFilters = () => {
        delete filters.current.download_type;
        delete filters.current.waste_type;
        delete filters.current.start;
        delete filters.current.end;
        filters.current.chosen = {};
        setFormFilters({...FormFiltersModel});
        setItemsShown([]);
        clearDateRange();
        applyFilters();
    };

    const selectDataRange = (start, end) => {
        //setDateRange([start, end]);
        const formattedStart = start ? moment(start).format("DD/MM/YYYY") : "";
        const formattedEnd = end ? moment(end).format("DD/MM/YYYY") : "";
        setDateRangeSelected(`${formattedStart} - ${formattedEnd}`);
        filters.current.start = formattedStart;
        filters.current.end = formattedEnd;
    };

    const clearDateRange = () => {
        const formattedStart = moment(defaultRange.current.start).format("DD/MM/YYYY");
        const formattedEnd = moment(defaultRange.current.end).format("DD/MM/YYYY");

        setDateRangeSelected(`${formattedStart} - ${formattedEnd}`);

        filters.current.start = formattedStart;
        filters.current.end = formattedEnd;
    };
    return (
        <Collapse in={show}>
            <div id="filter-collapse">
                <div className="row">
                    <Button
                        variant="link"
                        type="button"
                        onClick={handleClearFilters}
                        style={{color: "black"}}
                        className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("container.download_type")}
                        </label>
                        <DownloadTypesSelect
                            multiple={false}
                            value={formFilters.download_type}
                            onChange={onChangeSelect}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("container.waste_type")}
                        </label>
                        <WasteTypesSelect
                            multiple={false}
                            value={formFilters.waste_type}
                            onChange={onChangeSelect}
                        />
                    </div>

                    <div className="col" style={{maxWidth: "260px"}}>
                        <label style={labelStyle}>{_Tt("common.date")}</label>
                        <ButtonGroup className="w-100">
                            <Dropdown className="w-100">
                                <Dropdown.Toggle
                                    variant="Secondary"
                                    id="dropdown-basic"
                                    style={{
                                        border: "1px solid #ced4da",
                                        minWidth: "100%",
                                    }}
                                    className="custom-dropdown-toggle">
                                    <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                    <label style={{width: "90%", textAlign: "center"}}>
                                        {dateRangeSelected}
                                    </label>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <DataRange
                                        rangeData={selectDataRange}
                                        maxSpan={30}
                                        maxDate={new Date()}
                                    />
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
                    </div>
                
                    <div className="col pt-3 mt-2">
                        <button
                            type="button"
                            onClick={applyFilters}
                            className="btn btn-outline-primary me-3"
                            title="Aplicar"
                            disabled={isLoading}>
                            {isLoading ? (
                                <FontAwesomeIcon
                                    icon="circle-notch"
                                    className="fa-spin"
                                />
                            ) : (
                                <FontAwesomeIcon icon="magnifying-glass" />
                            )}{" "}
                            {_Tt("common.search")}
                        </button>
                    </div>
                </div>                
            </div>
        </Collapse>
    );
};

export default FleetRoutesFilters;
